import Layout from "../../components/Layout";
import Head from "next/head";
import GiftCardTab from "../../components/giftCards/giftcards";
import { useRouter } from "next/router";



const Giftcard = () => {

      
  const router = useRouter();
  const canonicalUrl = `https://kilimanjaro-restaurants.com${router.asPath.split('?')[0]}`;
      
 

  return (
    <>
      <Layout>
        <Head>
        <link rel="canonical" href={canonicalUrl} />
          <title>Kilimanjaro Gift Cards | Give the Gift of Great Food </title>
          <meta
            name="description"
            content="Give friends, family, or colleagues the gift of delicious meals with a Kilimanjaro Gift Card. Choose a gift card and make every meal more memorable."
          />

          <meta name="keyword" content="MEALS FOOD RESTAURANT NIGERIA" />

          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{
              __html: JSON.stringify({
                "@context": "https://schema.org",
                "@type": "WebSite",
                url: "https://kilimanjaro-restaurants.com",
                name: "Kilimanjaro",
                description:
                  "Kilimanjaro is one of the Sundry Foods’ restaurant brands, operating in the Quick Service Restaurant (QSR) segment, the brand has established itself as a market leader and one of the fastest-growing restaurant brands in the country with currently 59 stores across Nigeria and more to come.Kilimanjaro caters to the unique preference of the general populace in this part of sub-Saharan Africa for their local dishes. Our unique menu consists of select popular contemporary and Nigerian offerings. Items on our menu can also be found on dining tables in other African countries. The Kilimanjaro brand was born out of the quest to satisfy both the local and continental food cravings of our people. We deliver fresh, hot, and mouth-watering meals, pastries, sandwiches, and beverages to thousands of customers in the finest environment each day. Our restaurants stand out for their bright colors and lovely ambiance inviting you to dine-in or grab-and-go with the best quality meals.",
                publisher: {
                  "@type": "Organization",
                  name: "Kilimanjaro",
                },
                contactPoint: {
                  "@type": "ContactPoint",
                  telephone: "0700 5454 3663",
                  contactType: "customer support",
                },
              }),
            }}
          />

          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{
              __html: JSON.stringify({
                "@context": "https://schema.org",
                "@type": "Organization",
                name: "Kilimanjaro",
                url: "https://kilimanjaro-restaurants.com",
                contactPoint: {
                  "@type": "ContactPoint",
                  telephone: "0700 5454 3663",
                  contactType: "customer support",
                },
                address: {
                  "@type": "PostalAddress",
                  streetAddress: "23 Nzimiro street, Old GRA. Port Harcourt",
                  addressLocality: "Port Harcourt",
                  addressRegion: "Rivers",
                  addressCountry: "Nigeria",
                },
              }),
            }}
          />
        </Head>
        <h1 className="visually-hidden">
          Kilimanjaro Restaurant Giftcard Page
        </h1>

  
    <section>
    
<GiftCardTab/>

    </section>
    
      
      
      </Layout>
    </>
  );
};


export default Giftcard;
